/*
 * Secret Sale: text running clockwise around the screen edge.
 * The label is repeated along a rounded-rect path inside the frame band, each copy
 * one period apart, and the period divides the perimeter so the loop is seamless.
 */
(function () {
  var SVG_NS = 'http://www.w3.org/2000/svg';
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var uid = 0;

  function roundedRectPath(x, y, w, h, r) {
    r = Math.max(0, Math.min(r, w / 2, h / 2));
    return 'M' + (x + r) + ',' + y +
      ' H' + (x + w - r) + ' A' + r + ',' + r + ' 0 0 1 ' + (x + w) + ',' + (y + r) +
      ' V' + (y + h - r) + ' A' + r + ',' + r + ' 0 0 1 ' + (x + w - r) + ',' + (y + h) +
      ' H' + (x + r) + ' A' + r + ',' + r + ' 0 0 1 ' + x + ',' + (y + h - r) +
      ' V' + (y + r) + ' A' + r + ',' + r + ' 0 0 1 ' + (x + r) + ',' + y + ' Z';
  }

  function el(name, attrs) {
    var node = document.createElementNS(SVG_NS, name);
    for (var k in attrs) node.setAttribute(k, attrs[k]);
    return node;
  }

  function init(root) {
    var svg = root.querySelector('[data-ss-marquee]');
    if (!svg || svg.__ssInit) return;
    svg.__ssInit = true;

    var label = (svg.getAttribute('data-text') || 'Secret Sale').trim().toUpperCase();
    var unit = label + ' ';
    var speed = parseFloat(svg.getAttribute('data-speed')) || 45;
    var pathId = 'ss-marquee-path-' + (++uid);
    var state = { offset: 0, period: 0, nodes: [] };
    var lastW = 0;
    var lastH = 0;

    function measure(fontSize, count) {
      var probe = el('text', { 'font-size': fontSize, 'text-rendering': 'geometricPrecision', x: 0, y: -1000 });
      probe.textContent = new Array(count + 1).join(unit);
      svg.appendChild(probe);
      var len = probe.getComputedTextLength();
      svg.removeChild(probe);
      return len;
    }

    function build() {
      var w = root.clientWidth;
      var h = root.clientHeight;
      if (!w || !h) return;
      lastW = w;
      lastH = h;

      var cs = getComputedStyle(root);
      var band = parseFloat(cs.getPropertyValue('--ss-band')) || 48;
      var radius = parseFloat(cs.getPropertyValue('--ss-radius')) || 0;
      var fontSize = band * 0.6;
      var cap = fontSize * 0.7;
      var inset = band / 2 + cap / 2;
      var r = radius + (band - inset);

      while (svg.firstChild) svg.removeChild(svg.firstChild);
      svg.setAttribute('viewBox', '0 0 ' + w + ' ' + h);

      var defs = el('defs', {});
      var path = el('path', { id: pathId, d: roundedRectPath(inset, inset, w - 2 * inset, h - 2 * inset, r), fill: 'none' });
      defs.appendChild(path);
      svg.appendChild(defs);

      var length = path.getTotalLength();
      var unitLen = measure(fontSize, 10) / 10;
      if (!unitLen) return;
      var count = Math.max(1, Math.round(length / unitLen));

      // Scale the font so `count` labels fill the perimeter as closely as possible.
      fontSize = fontSize * length / (count * unitLen);

      // One text node per label, each placed exactly one period apart. Browsers round
      // glyph advances, so a single long string would drift and squeeze the seam.
      state.nodes = [];
      for (var k = 0; k <= count; k++) {
        var text = el('text', { 'font-size': fontSize, 'text-rendering': 'geometricPrecision' });
        var tp = el('textPath', { href: '#' + pathId, startOffset: 0 });
        tp.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', '#' + pathId);
        tp.textContent = label;
        text.appendChild(tp);
        svg.appendChild(text);
        state.nodes.push(tp);
      }

      state.period = length / count;
      state.offset = state.offset % state.period;
      render();
    }

    function render() {
      // Labels cover [offset - period, offset + length]; glyphs off either end of the
      // closed path are not drawn, so each one shows exactly once.
      for (var k = 0; k < state.nodes.length; k++) {
        state.nodes[k].setAttribute('startOffset', state.offset + (k - 1) * state.period);
      }
    }

    var last = null;
    function frame(t) {
      if (last !== null && state.period) {
        state.offset = (state.offset + speed * Math.min(t - last, 100) / 1000) % state.period;
        render();
      }
      last = t;
      requestAnimationFrame(frame);
    }

    var pending = false;
    function scheduleBuild() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        if (root.clientWidth !== lastW || root.clientHeight !== lastH) build();
      });
    }

    var start = function () {
      build();
      if (!reduceMotion) requestAnimationFrame(frame);
      if ('ResizeObserver' in window) {
        new ResizeObserver(scheduleBuild).observe(root);
      } else {
        window.addEventListener('resize', scheduleBuild);
      }
    };

    if (document.fonts && document.fonts.ready) {
      document.fonts.load('800 20px "Secret Sale Condensed"').then(start, start);
    } else {
      start();
    }
  }

  // The loader fades out via CSS; once it is gone, take it out of the DOM so no
  // full-screen fixed layer is left above the page (iOS Safari can keep routing
  // swipes to it, which stops the page from scrolling).
  function initLoader(root) {
    var loader = root.querySelector('.secret-sale__loader');
    if (!loader || loader.__ssInit) return;
    loader.__ssInit = true;
    var ms = parseFloat(getComputedStyle(root).getPropertyValue('--ss-loader-ms')) || 2500;
    setTimeout(function () { loader.classList.add('is-done'); }, ms + 250);
    setTimeout(function () { if (loader.parentNode) loader.parentNode.removeChild(loader); }, ms + 900);
  }

  function initAll() {
    document.querySelectorAll('[data-secret-sale]').forEach(function (root) {
      initLoader(root);
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) e.target.querySelectorAll('[data-secret-sale]').forEach(function (root) {
      initLoader(root);
      init(root);
    });
  });
})();
